// Simple connector script to ensure the slider pagination has the correct value
(function() {
  // Run as soon as possible
  if (document.readyState !== 'loading') {
    initializeSlider();
  } else {
    document.addEventListener('DOMContentLoaded', initializeSlider);
  }
  
  // Also run when recommendations are loaded
  document.addEventListener('recommendations:loaded', function() {
    setTimeout(initializeSlider, 100);
  });
  
  // Initialize the product card pagination on load
  document.addEventListener('complementary-slider:initialized', function(event) {
    if (event.detail && event.detail.swiper) {
      const swiper = event.detail.swiper;
      const totalCount = event.target.productCount || 3;
      
      updateProductCardPagination(swiper, totalCount);
      updateProductCardButtonStates(swiper);
    }
  });
  
  // Minimal initialization to ensure pagination is correct
  function initializeSlider() {
    // Find the slider element
    const sliderElement = document.querySelector('complementary-product-slider');
    
    if (!sliderElement) {
      return;
    }
    
    // Find the swiper element
    const swiperElement = sliderElement.querySelector('.swiper');
    if (!swiperElement || !swiperElement.swiper) {
      return;
    }
    
    // Ensure the slide count is set correctly from the product block
    if (sliderElement.closest('.product__block') && sliderElement.closest('.product__block').dataset.complementaryCount) {
      const count = parseInt(sliderElement.closest('.product__block').dataset.complementaryCount, 10);
      if (count > 0) {
        sliderElement.dataset.slideCount = count;
        
        // Also update product card pagination
        updateProductCardPagination(swiperElement.swiper, count);
        updateProductCardButtonStates(swiperElement.swiper);
      }
    }
    
    // Force the slider to update its pagination
    if (typeof sliderElement.updatePaginationControls === 'function' && swiperElement.swiper) {
      sliderElement.updatePaginationControls(swiperElement.swiper);
    }
  }
  
  // Helper function to update product card pagination
  function updateProductCardPagination(swiper, totalCount) {
    if (!swiper) return;
    
    const currentSlide = ((swiper.realIndex) % totalCount) + 1;
    
    // Update all current-slide elements in product cards
    document.querySelectorAll('.product-card__nav-count .current-slide').forEach(el => {
      el.textContent = currentSlide;
    });
    
    // Update all total-slides elements in product cards
    document.querySelectorAll('.product-card__nav-count .total-slides').forEach(el => {
      el.textContent = totalCount;
    });
  }
  
  // Helper function to update button states based on slider position
  function updateProductCardButtonStates(swiper) {
    if (!swiper) return;
    
    // Find all product card prev/next buttons
    const prevButtons = document.querySelectorAll('.product-card__nav-prev');
    const nextButtons = document.querySelectorAll('.product-card__nav-next');
    
    // For non-loop sliders, disable buttons when at beginning/end
    if (!swiper.params.loop) {
      // Update previous buttons (disabled at beginning)
      prevButtons.forEach(button => {
        if (swiper.isBeginning) {
          button.classList.add('disabled');
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.classList.remove('disabled');
          button.setAttribute('aria-disabled', 'false');
        }
      });
      
      // Update next buttons (disabled at end)
      nextButtons.forEach(button => {
        if (swiper.isEnd) {
          button.classList.add('disabled');
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.classList.remove('disabled');
          button.setAttribute('aria-disabled', 'false');
        }
      });
    } else {
      // If loop is enabled, make sure buttons aren't disabled
      prevButtons.forEach(button => {
        button.classList.remove('disabled');
        button.setAttribute('aria-disabled', 'false');
      });
      nextButtons.forEach(button => {
        button.classList.remove('disabled');
        button.setAttribute('aria-disabled', 'false');
      });
    }
  }
})(); 